import { z } from "zod"
import { isValidCNPJ, isValidCPF } from '../utils/formatDocuments';

export const schemaCard = z.object({
  informacoesTitularCartao: z.object({
    nome: z
      .string()
      .min(3, "O nome deve ter pelo menos 3 caracteres")
      .refine((value) => value.trim() !== "", "O nome não pode ser vazio"),
    email: z
      .string()
      .email("Email inválido")
      .refine((value) => value.trim() !== "", "O email não pode ser vazio"),
    cpfCnpj: z
      .string()
      .refine((value) => value.trim() !== "", "O CPF ou CNPJ não pode ser vazio")
      .refine(
        (value) => isValidCPF(value) || isValidCNPJ(value),
        "CPF ou CNPJ inválido"
      ),
    numeroEndereco: z
      .string()
      .min(1, "O número do endereço deve ter pelo menos 1 caractere"),
    complementoEndereco: z
      .string()
      .optional(),
    cep: z
    .string()
    .regex(/^\d{5}-\d{3}$/, "CEP inválido")
    .refine((value) => value.trim() !== "", "CEP não pode ser vazio"),
    telefone: z
    .string()
    .regex(/^\(\d{2}\) \d{4,5}-\d{4}$/, "Telefone inválido")
    .refine(value => value.trim() !== "", "O telefone não pode ser vazio"),
  }),
  cartaoCredito: z.object({
    nomeTitular: z
      .string()
      .min(3, "O nome do titular deve ter pelo menos 3 caracteres")
      .refine((value) => value.trim() !== "", "O nome do titular não pode ser vazio"),
    numero: z
      .string()
      .regex(/^\d{4} \d{4} \d{4} \d{4}$/, "Número do cartão inválido")
      .refine((value) => value.trim() !== "", "O número do cartão não pode ser vazio"),
    ccv: z
      .string()
      .length(3, "O CCV deve conter 3 dígitos"),
     
    anoExpiracao: z
      .string()
      .length(4, "O ano de expiração deve conter 4 dígitos")
      .refine(
        (value) => /^[0-9]+$/.test(value),
        "O ano de expiração deve conter apenas dígitos"
      )
      .refine(
        (value) => new Date().getFullYear() <= parseInt(value, 10),
        "O ano de expiração deve ser igual ou maior que o ano atual"
      ),
    mesExpiracao: z
      .string()
      .length(2, "O mês de expiração deve conter 2 dígitos")
      .refine(
        (value) => /^[0-9]+$/.test(value),
        "O mês de expiração deve conter apenas dígitos"
      )
      .refine(
        (value) => {
          const month = parseInt(value, 10);
          return month >= 1 && month <= 12;
        },
        "O mês de expiração deve ser entre 01 e 12"
      ),
  }),
  idUsuario: z
    .number()
    .optional(),
  unidadeId: z.number().optional(),
});

export type CardFormData = z.infer<typeof schemaCard>


export interface Card {
  id: number
  numero: string
  bandeira: string
  token: string
  cliente: Cliente
}

export interface Cliente {
  id: number
  inclusao: string
  alteracao: any
  status: number
  idAcademia: number
  idUnidade: number
  idUsuario: number
  integracaoId: string
  cpfCnpj: string
  email: any
  nome: any
}
